import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { JsonldService } from 'src/app/Service/jsonld.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { UserService } from 'src/app/User/Service/user.service';
import { GlobalConstants } from 'src/app/utils/global-constants';
import { ContactUsService } from './contactus.service';
import { Meta,Title } from '@angular/platform-browser';

@Component({
    selector: 'app-contactus',
    templateUrl: './contactus.component.html',
    styleUrls: ['./contactus.component.css'],
    standalone: false
})
export class ContactusComponent implements OnInit {
  @ViewChild('pricing') pricing;

  contactMsgForm: UntypedFormGroup;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private contactService: ContactUsService,
    private notificationService: NotificationService,
    private jsonldService: JsonldService,
    private meta: Meta,
    private title: Title
  ) {
    this.title.setTitle('Contact US | Family Central');
    this.meta.addTag({
      name: 'description',
      content:
        'Have a question? Reach out to us and our dedicated team will provide the support you need.',
    });
  }
  ngOnInit(): void {
    this.setJsonLdSchema();
    this.contactMsgForm = this.SetFormGroup();
    this.loader.HideLoading();
  }
  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  onClose() {
    this.modalService.dismissAll();
  }

  SetFormGroup() {
    return this.fb.group({
      firstName: [null],
      lastName: [null],
      description: [null],
      ipAddress: [null],
      phoneNumber: [
        null,
        [
          Validators.required,
          Validators.pattern(GlobalConstants.phoneNumberPattern),
        ],
      ],
      email: [null, [Validators.pattern(GlobalConstants.emailPattern)]],
    });
  }

  Send() {
    this.contactMsgForm.markAllAsTouched();
    if (this.contactMsgForm.valid) {
      this.contactService
        .PostContactMassage(this.contactMsgForm.value)
        .subscribe((data) => {
          if (data) {
            this.notificationService.showSuccess('Send Successfully');
            this.contactMsgForm.reset();
          }
        });
    }
  }

  setJsonLdSchema() {
    const jsonLdData = {
      '@context': 'http://schema.org',
      '@type': 'ContactPage',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': 'ContactUS',
      },
      url: 'https://www.familycentral.com/contact-us',
      headline: 'Contact Us | FamilyCentral',
      publisher: {
        '@type': 'Organization',
        '@id': ' https://www.familycentral.com/aboutus',
        name: 'FamilyCentral',
        logo: {
          '@type': 'ImageObject',
          url: ' https://familycentral.com/assets/img/family-central-logo.png',
          width: 242,
          height: 44,
        },
      },
      description:
        'Have questions or comments about FamilyCentral? Contact us here!',
    };
    this.jsonldService.setJsonLdData(jsonLdData);
  }
}
